import { render, staticRenderFns } from "./MyCaptcha.vue?vue&type=template&id=99df366c&scoped=true&"
import script from "./MyCaptcha.vue?vue&type=script&lang=js&"
export * from "./MyCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./MyCaptcha.vue?vue&type=style&index=0&id=99df366c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99df366c",
  null
  
)

export default component.exports